/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

import loadComponents from '../utilities/load-components';
import Layout from '../components/layout';
import SEO from '../components/seo';
import collaboratorsImage from '../assets/images/collaborators.svg';

const IndexPage = () => {
    const [components, setComponents] = useState(null);

    useEffect(() => {
        (async function() {
            setComponents(await loadComponents());

            if (components) {
                console.log('Componenet location', components['example-block-1'].location);
            }
        })();
    }, []);

    return (
        <Layout>
            <SEO title="Style Tile - A curated collection of HTML, CSS and JS" />

            <div className="c-banner">
                <img className="c-banner__image" src={collaboratorsImage} alt="Pair collaborating on a website" />
    
                <div className="c-banner__content">
                    <span className="c-banner__sub-title">Coming Soon</span>
                    <h1 className="c-banner__title">Style Tile</h1>
                    <p className="c-banner__desc">A curated collection of HTML, CSS and JS that allows you to generate a style tile to start your next project.</p>
                    <p className="c-banner__desc">Style Tile generates custom, fully editable source code and accompanying style tile for utilities and components to speed up development.</p>
                </div>
            </div>
        </Layout>
    );
};

export default IndexPage;
